import { render, staticRenderFns } from "./Inventory.vue?vue&type=template&id=38268660&scoped=true&"
import script from "./Inventory.vue?vue&type=script&lang=js&"
export * from "./Inventory.vue?vue&type=script&lang=js&"
import style0 from "./Inventory.vue?vue&type=style&index=0&id=38268660&prod&lang=css&"
import style1 from "./Inventory.vue?vue&type=style&index=1&id=38268660&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38268660",
  null
  
)

export default component.exports